module.exports = __webpack_public_path__ + "img/logo.7fb8883d.png";